// must end with a '/'
export const SW_DL_PREFIX = '/download/sw/';
